import { getParameterByName } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
import { UIWStoreBodyController } from './UIWStoreBodyController.ts';
import { notificationController } from '../../../shared/scripts/EntryShared.ts';
import { UITopNotificationType } from '../../../shared/scripts/notifications/UINotificationController.ts';
import { UIStoreState } from '../../../shared/scripts/store/UIStoreState.ts';
import { UIStoreController } from '../../../shared/scripts/store/UIStoreController.ts';
import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { shouldHideCoinsSection } from '../../../shared/scripts/store/StoreUtils.ts';
import { sendStoreTabsClickedAnalytic } from '../../../shared/scripts/analytics/sendStoreTabsClickedAnalytic.ts';
import { setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
export class UIWStoreController extends UIStoreController {
    init() {
        this.storeState = new UIStoreState(this);
        this.bodyController = this.createBodyController();
        this.bodyController.onStoreViewVisible();
        if (this.shouldSetupCoinSectionVisibility()) UIWStoreController.setupCoinSectionVisibility();
        this.setupSidebarTabAnalytics();
    }
    createBodyController() {
        return new UIWStoreBodyController(this.storeState);
    }
    // eslint-disable-next-line class-methods-use-this
    shouldSetupCoinSectionVisibility() {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    setupSidebarTabAnalytics() {
        const sidebarButtons = document.querySelectorAll('.singleton_page_sidebar_button');
        sidebarButtons.forEach((button)=>{
            const hash = button.getAttribute('href');
            if (hash == null) return;
            const tabName = hash.replace('#', '');
            setElementOnClick(button, ()=>sendStoreTabsClickedAnalytic(tabName));
        });
    }
    static setupCoinSectionVisibility() {
        const coinsSection = document.getElementById('coins');
        if (coinsSection == null) return;
        const coinsLink = document.getElementById('store_coins_link');
        if (coinsLink == null) return;
        ClientUserState.registerChangeListener((userState)=>{
            if (userState == undefined) return;
            const hideCoins = shouldHideCoinsSection(userState.forceSubscription);
            coinsSection.hidden = hideCoins;
            coinsLink.hidden = hideCoins;
        });
    }
    static showSuccessBanner() {
        const purchaseSuccess = getParameterByName('purchase-success');
        if (purchaseSuccess != '1') return;
        notificationController.show({
            key: 'strings:storePage.success.purchaseSuccess'
        }, UITopNotificationType.Success);
        CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.PurchaseCompleted);
    }
    constructor(){
        super();
        this.init();
        UIWStoreController.showSuccessBanner();
    }
}
